import Vue from 'vue';
import format from 'date-fns/format';

/*const formatDateTime = (value, formatString = 'YYYY-MM-DD HH:mm') =>
  value ? format(value, formatString) : '';
export default formatDateTime;

Vue.filter('formatDateTime', formatDateTime);*/

const formatDateTime = (value, formatString = 'YYYY-MM-DD HH:mm') =>
  value ? format(value, formatString) : '';
export default formatDateTime;

Vue.filter('formatDateTime', formatDateTime);
